import React, { Component } from 'react';
import { Button, Col, Form  } from 'reactstrap';
import SelectFiltro from '../../comum/components/SelectFiltro';
import InputFiltro from '../../comum/components/InputFiltro';
import CardAtencao from '../../comum/components/CardAtencao';
import { IconeInformacao, Fechar } from '../../comum/components/Icones';
import { inject, observer } from 'mobx-react';
import Card from '../../comum/components/Card';
import lscache from 'lscache';

@inject("store")
@observer
export default class FiltroAcomp extends Component {

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    componentDidMount () {    
        const botaoVoltar = lscache.get('acompProcesso-pesquisa-voltar'); 
        if (botaoVoltar)  {
            lscache.remove('acompProcesso-pesquisa-voltar');
            this.controller.documento = lscache.get('acompProcesso-doc');
            lscache.get('acompProcesso-navio') ? this.controller.navioSelecionado = lscache.get('acompProcesso-navio') : 
                                                 this.controller.navioSelecionado = {};
            lscache.get('acompProcesso-navio') ? this.controller.solicitaNavio = true : this.controller.solicitaNavio = false;
            this.controller.filtrar();
        }
        else {
            lscache.remove('acompProcesso-pesquisa-doc');
            lscache.remove('acompProcesso-doc');
            lscache.remove('acompProcesso-navio');        
            lscache.remove('acompProcesso-notaTecon');    
        }  
    }


    filtrar = (e) => {
        e.preventDefault();
        this.controller.filtrar();
    }

    handleBlur = (event, e) => {
      this.controller.filtrar();
    }

    alertaSSA = () => {
        let alerta = ( <div />);
        if (this.controller.tipoAcompanhamento && ["I", "C"].includes(this.controller.tipoAcompanhamento)) {
            alerta = (
                <div className="card-atencao float-right">
                    <div className="d-flex w-100 justify-content-between align-items-center pb-2">
                        <div className="card-atencao--title"> 
                            NOTA
                        </div>
                            <Fechar tamanho="1x" className="card-atencao--close" onClick={() => this.controller.fechaAlerta()} />                                    
                    </div>
                    <div className={this.classLabel}>
                        <p className="mb-0 ml-1">
                            <label className="label-disabled"> Caso sua condição de pagamento seja à vista, favor realizar pagamento antes da liberação documental da carga.<br/>Lembre-se de manter seu cadastro atualizado. <a href="https://atendimento.teconsvonline.com.br/hc/pt-br/articles/360048461712" target="_blank">Clique aqui</a> e saiba mais.</label>
                        </p>
                    </div>
                </div>
            )
        }
        return alerta;  
    }

    alertaRIG = () => {
        let alerta = ( <div />);        
        if (this.controller.tipoAcompanhamento && ["I"].includes(this.controller.tipoAcompanhamento)) {
            alerta = (
                    <div className="card-atencao float-right">
                        <div className="d-flex w-100 justify-content-between align-items-center pb-2">
                            <div className="card-atencao--title"> 
                                OBSERVAÇÃO E OUTROS DADOS
                            </div>
                                <Fechar tamanho="1x" className="card-atencao--close" onClick={() => this.controller.fechaAlerta()} />                                    
                        </div>
                        <div className={this.classLabel}>
                            <p className="mb-0 ml-1">
                                <p><label className="label-disabled">Por favor, confira se os dados do BL estão de acordo com o processo (CNPJ e Razão Social). Qualquer divergência, contacte o Import Desk.</label></p>                                    
                            </p>
                        </div>
                    </div>
                )
        }
        return alerta; 
    }

    render() {
        return (
                <Form onSubmit = {this.filtrar}>
                    <div className={`filtros ${window.innerWidth < 991 ? "mb-1" : ""}`}>
                        <div className={`d-flex align-items-center mb-1`}>
                            <Col className="mb-1 w-100 pl-0" xs={12} sm={6} md={4} lg={4} xl={3}>
                                <InputFiltro className="mb-1 w-100 pl-0"
                                             titulo= {process.env.rig ? "BL house / CE / DI / DUE / CTe / Booking Exp" : "BL house / CE / DI / CTe / Booking Exp"}
                                             value={lscache.get('acompProcesso-pesquisa-voltar') ? lscache.get('acompProcesso-doc') : ""}
                                             onChange={(event) => this.controller.setBlHouse(event.target.value)} />
                            </Col>
                            {this.controller.solicitaNavio &&
                                <SelectFiltro className="mb-1"
                                              titulo="Navio" xl={3} lg={6} md={4} sm={6} xs={12}
                                              itens={this.controller.naviosCE}
                                              valor={this.controller.navioSelecionado}
                                              naoLimpar={true}
                                              itensValor="Ce" itensLabel="Navio"
                                              onChange={this.controller.setNavio} 
                                />
                            }
                            <Button
                                className="ml-3 mt-3 mb-1 btn-com-bordas-primary btn-filtrar"
                                onClick={() => { lscache.remove('acompProcesso-pesquisa-doc'); this.controller.filtrar()}}
                            >
                                Filtrar
                            </Button>
                            <div className={`mb-1 mt-3 pl-3 d-flex justify-content-start align-items-center`}>
                                <IconeInformacao tamanho="2x" className="mr-1" />
                                <label className="ml-1 mr-0 w-50">Informe o número do seu documento (importação, exportação ou cabotagem) e acompanhe o andamento de todo seu processo.</label>
                            </div>
                            { 
                              this.controller.alerta ?                              
                                    process.env.rig ? this.alertaRIG() : this.alertaSSA() : 
                               <div />
                            }   
                        </div>
                    </div>
                </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/FiltroAcomp.js